/* import __COLOCATED_TEMPLATE__ from './created-at-cell.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';

interface Args {
  contentWrapper: ContentWrapper;
}

export default class CreatedAtCell extends Component<Args> {
  @service declare appService: $TSFixMe;

  get createdAt(): Date {
    if (this.appService.app.canUseAiInsightsSuggestionsUi) {
      return this.args.contentWrapper.contents.firstObject?.contentData
        .most_recent_content_review_request_created_at;
    } else {
      return this.args.contentWrapper.contents.firstObject!.createdAt;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::List::Cells::CreatedAtCell': typeof CreatedAtCell;
  }
}
